import { render, staticRenderFns } from "./AuthorizeFormsQueue.vue?vue&type=template&id=11e81bbe"
import script from "./AuthorizeFormsQueue.vue?vue&type=script&lang=js"
export * from "./AuthorizeFormsQueue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports